import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const VideosPhotosIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-videosPhotos"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 34 68 34 68 0 0 0" />
        <path
          d="M40.0302,8.5185 C40.4782,7.8275 41.5222,7.8275 41.9702,8.5185 L46.5002,15.5105 L52.0002,23.9995 L41.0002,23.9995 L30.0002,23.9995 L35.5002,15.5105 L40.0302,8.5185 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M54.2271,16.3454 C54.6021,15.8854 55.3981,15.8854 55.7731,16.3454 L58.5001,19.6974 L62.0001,24.0004 L55.0001,24.0004 L48.0001,24.0004 L51.5001,19.6974 L54.2271,16.3454 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M60,0 L32,0 C30.3427153,0 29,1.34271525 29,3 L29,23 C29,24.6572847 30.3427153,26 32,26 L60,26 C61.6572847,26 63,24.6572847 63,23 L63,3 C63,1.34271525 61.6572847,0 60,0 Z M32,2 L60,2 C60.5527153,2 61,2.44728475 61,3 L61,23 C61,23.5527153 60.5527153,24 60,24 L32,24 C31.4472847,24 31,23.5527153 31,23 L31,3 C31,2.44728475 31.4472847,2 32,2 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M52,8 C52,9.657 53.343,11 55,11 C56.657,11 58,9.657 58,8 C58,6.343 56.657,5 55,5 C53.343,5 52,6.343 52,8"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M9,33 L35,33 C36.657,33 38,31.657 38,30 L38,12 C38,10.343 36.657,9 35,9 L9,9 C7.343,9 6,10.343 6,12 L6,30 C6,31.657 7.343,33 9,33"
          fill="#ffffff"
          className={styles.white}
        />
        <path
          d="M35,8 L9,8 C6.79071525,8 5,9.79071525 5,12 L5,30 C5,32.2092847 6.79071525,34 9,34 L35,34 C37.2092847,34 39,32.2092847 39,30 L39,12 C39,9.79071525 37.2092847,8 35,8 Z M9,10 L35,10 C36.1047153,10 37,10.8952847 37,12 L37,30 C37,31.1047153 36.1047153,32 35,32 L9,32 C7.89528475,32 7,31.1047153 7,30 L7,12 C7,10.8952847 7.89528475,10 9,10 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M9.5,30.5 L34.5,30.5 C35.052,30.5 35.5,30.052 35.5,29.5 L35.5,12.5 C35.5,11.948 35.052,11.5 34.5,11.5 L9.5,11.5 C8.948,11.5 8.5,11.948 8.5,12.5 L8.5,29.5 C8.5,30.052 8.948,30.5 9.5,30.5"
          fill="#ffffff"
          className={styles.white}
        />
        <path
          d="M34.5,11 L9.5,11 C8.67185763,11 8,11.6718576 8,12.5 L8,29.5 C8,30.3281424 8.67185763,31 9.5,31 L34.5,31 C35.3281424,31 36,30.3281424 36,29.5 L36,12.5 C36,11.6718576 35.3281424,11 34.5,11 Z M9.5,12 L34.5,12 C34.7758576,12 35,12.2241424 35,12.5 L35,29.5 C35,29.7758576 34.7758576,30 34.5,30 L9.5,30 C9.22414237,30 9,29.7758576 9,29.5 L9,12.5 C9,12.2241424 9.22414237,12 9.5,12 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M25.604,20.2741 C26.132,20.6131 26.132,21.3871 25.604,21.7261 L22.367,23.8061 L19.13,25.8861 C18.628,26.2091 18,25.8061 18,25.1601 L18,21.0001 L18,16.8391 C18,16.1941 18.628,15.7911 19.13,16.1131 L22.367,18.1941 L25.604,20.2741 Z"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
      </g>
    </Icon>
  )
}
